import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ApiServices from "../config/ApiServices";
import { setData } from "../redux/actions/DataAction";

export default function Sidebar(){
    const batches=useSelector((state)=>state.data.data)
    const dispatch=useDispatch()
    const userId=sessionStorage.getItem("userId")
    useEffect(() => {
  ApiServices.apiRequest("getAssignStudent", {})
    .then((result) => {
      const filteredData = result.data.data.filter((batch) =>
        batch.students.some(
          (student) =>
            student.studentId?._id === userId && student.studentstatus === true
        )
      );

      dispatch(setData(filteredData));
      console.log("Filtered student sidebar data:", filteredData);
    })
    .catch((err) => {
      console.log(err);
    });
}, [dispatch, userId]);

    return(
        <>
         <div className="sidebar" data-background-color="dark">
            <div className="sidebar-logo">
            {/* Logo Header */}
            <div className="logo-header" data-background-color="dark">
                <Link to={'/student'} className="logo text-light fs-4">
                <img
                    src="/assets/img/logo2.png"
                    alt="navbar brand"
                    className="navbar-brand"
                    height={40}
                /> 
                </Link>
                <div className="nav-toggle">
                <button className="btn btn-toggle toggle-sidebar">
                    <i className="gg-menu-right" />
                </button>
                <button className="btn btn-toggle sidenav-toggler">
                    <i className="gg-menu-left" />
                </button>
                </div>
                <button className="topbar-toggler more">
                <i className="gg-more-vertical-alt" />
                </button>
            </div>
            {/* End Logo Header */}
            </div>
            <div className="sidebar-wrapper scrollbar scrollbar-inner">
            <div className="sidebar-content">
                <ul className="nav nav-secondary">
                <li className="nav-item ">
                    <Link
                    to={"/student"}
                    >
                    <i className="fas fa-home" />
                    <p>Dashboard</p>
                    </Link>
                </li>
                <li className="nav-section">
                    <span className="sidebar-mini-icon">
                    <i className="fa fa-ellipsis-h" />
                    </span>
                    <h4 className="text-section">View</h4>
                </li>
                {
                    batches?.length>0?
                    batches?.map((el,index)=>(
                        <li className="nav-item">
                        <a data-bs-toggle="collapse" href={`#${index}`}>
                        <i className="fas fa-layer-group" />
                        <p>{el?.batchId?.name}<br/><span style={{fontSize:"0.9rem"}}>{el?.time}</span></p>
                        <span className="caret" />
                        </a>
                        <div className="collapse" id={index}>
                        <ul className="nav nav-collapse">
                            {/* <li>
                            <Link to={`/student/schedules/${el?.batchId?._id}`}>
                                <span className="sub-item">Schedule</span>
                            </Link>
                            </li> */}
                            <li>
                            <Link to={`/student/material/${el?.batchId?._id}`}>
                                <span className="sub-item">Material</span>
                            </Link>
                            </li>
                            <li>
                            <Link to={`/student/tasks/${el?.batchId?._id}`}>
                                <span className="sub-item">Tasks</span>
                            </Link>
                            </li>
                            <li>
                            <Link to={`/student/trainers/${el?.batchId?._id}`}>
                                <span className="sub-item">Trainers</span>
                            </Link>
                            </li>
                        </ul>
                        </div>
                    </li>
                    ))
                    :
                    <li className="nav-item">
                        <Link to="/student/batches">
                        <i className="fas fa-layer-group" />
                        <p>Batches</p>
                        </Link>
                    </li>
                }
                </ul>
            </div>
            </div>
        </div>
        </>
    )
}